/**
 * @generated SignedSource<<79d8693644761f8a0e72f9d5e88dbad9>>
 * @relayHash c8313cb6deaff20894c7c877e9fac649
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c8313cb6deaff20894c7c877e9fac649

import { ConcreteRequest } from 'relay-runtime';
export type RegisterVisitorUserProfileViewEventInput = {
  currentUrl?: any | null;
  referrerUrl?: any | null;
  userProfileId: string;
};
export type useSendAnalyticEventMutationProfileViewEventMutation$variables = {
  input: RegisterVisitorUserProfileViewEventInput;
};
export type useSendAnalyticEventMutationProfileViewEventMutation$data = {
  readonly registerVisitorUserProfileViewEvent: {
    readonly registered: boolean;
  };
};
export type useSendAnalyticEventMutationProfileViewEventMutation = {
  response: useSendAnalyticEventMutationProfileViewEventMutation$data;
  variables: useSendAnalyticEventMutationProfileViewEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RegisterVisitorUserProfileViewEventPayload",
    "kind": "LinkedField",
    "name": "registerVisitorUserProfileViewEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "registered",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSendAnalyticEventMutationProfileViewEventMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSendAnalyticEventMutationProfileViewEventMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "c8313cb6deaff20894c7c877e9fac649",
    "metadata": {},
    "name": "useSendAnalyticEventMutationProfileViewEventMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e6e37783afedebb39852b24c91708d46";

export default node;
